import { Placeholder } from '../components/Placeholder.js';

export default function NotFound() {
  return <Placeholder title="Page not found" route="*" phase="—" />;
}
